"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pipe = pipe;
function pipe(value, ...operations) {
    return operations.reduce((acc, op) => op(acc), value);
}
//# sourceMappingURL=pipe.js.map